const data = {
  title: "M Ibrahim",
  sub_title: "yaibrahim • he/him",
  aboutme: `I am a dynamic Software Developer with a knack for solving complex problems and a track record of designing top-notch software in test-driven environments. With over 3 years of experience specializing in Ruby on Rails (RoR), I bring innovation and expertise to every project..`,
  bio: `
    Software Engineer 🧑‍💻 <br />
    • Snapchat👻: ibrahimazeem41 <br />
    • Gym Freak 🔩 <br />
    • Love Challenges <br />
    • We create our own demons <br />
  `,
};

export default data;
